import axios from "axios";
import { API_BASE_URL } from "../configs/variable.config";
import { history } from "../helpers/history";
import { handleErrorState } from "../HandleSlice/HandleSlice";

export function service() {
  const cookie = document.cookie;

  axios.interceptors.request.use((request) => {
    request.baseURL = API_BASE_URL;
    request.headers = {
      Authorization: "Bearer " + cookie.split("=").at(-1),
      Accept: "application/json",
    };
    return request;
  });

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response === undefined) {
        return;
      } else if (error.response.status === 404) {
        history.dispatch(handleErrorState(404));
      } else if (error.response.status === 401) {
        history.navigate("/login");
        localStorage.removeItem("Authorization");
      } else if (error.response.status === 500) {
        history.dispatch(handleErrorState(500));
      }
      throw error;
    }
  );
}
